import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page-login"
  }, [_c("img", {
    staticClass: "page-login-bg",
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260803/1785723948431.png",
      alt: ""
    }
  }), _c("div", {
    staticClass: "content"
  }, [_c("div", {
    staticClass: "top"
  }, [_c("router-link", {
    staticClass: "header",
    staticStyle: {
      left: "auto",
      right: "20px"
    },
    attrs: {
      to: "/index"
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: require("./image/workshop/logo.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("智慧渔业管控平台")])])], 1), _c("div", {
    staticClass: "center"
  }, [_c("div", {
    staticClass: "left"
  }, [_vm._m(0), _vm._m(1), _c("div", {
    staticClass: "item item-3"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("省域产值统计（单位：万吨）")]), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "rank"
  }, _vm._l(_vm.sales_list, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "rank-item"
    }, [_c("div", {
      staticClass: "label"
    }, [_vm._v("No." + _vm._s(index + 1) + " " + _vm._s(item.area))]), _c("div", {
      staticClass: "bar"
    }, [_c("div", {
      staticClass: "color",
      style: "width:".concat(item.sales / _vm.sales_max * 100, "%")
    }), _c("div", {
      staticClass: "line"
    })]), _c("div", {
      staticClass: "value"
    }, [_vm._v(_vm._s(item.sales))])]);
  }), 0)])])]), _c("div", {
    staticClass: "middle"
  }, [_c("div", {
    staticClass: "middle-top"
  }, [_c("div", {
    staticStyle: {
      "border-left": "2px solid #0BB7FF"
    }
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("养殖总面积")]), _c("img", {
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260804/1785833127773.png",
      alt: ""
    }
  }), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.LabReportInfo.cultureArea || 0))])]), _c("div", {
    staticStyle: {
      "border-right": "2px solid #0BB7FF"
    }
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("物联网装备数")]), _c("img", {
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260804/1785833127773.png",
      alt: ""
    }
  }), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s((_vm.LabReportInfo.amountCollector || 0) + (_vm.LabReportInfo.amountSensor || 0) + (_vm.LabReportInfo.amountRobot || 0) + (_vm.LabReportInfo.amountFeeder || 0) + (_vm.LabReportInfo.amountCamera || 0) + (_vm.LabReportInfo.amountUav || 0) + (_vm.LabReportInfo.amountUgv || 0) + (_vm.LabReportInfo.amountUsv || 0)))])])]), _c("div", {
    staticClass: "middle-bottom"
  }, [_c("div", {
    staticStyle: {
      "border-left": "2px solid #0BB7FF"
    }
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("采集器")]), _c("img", {
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260804/1785833127773.png",
      alt: ""
    }
  }), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.LabReportInfo.amountCollector || 0))])]), _c("div", [_c("div", {
    staticClass: "label"
  }, [_vm._v("传感器")]), _c("img", {
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260804/1785833127773.png",
      alt: ""
    }
  }), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.LabReportInfo.amountSensor || 0))])]), _c("div", [_c("div", {
    staticClass: "label"
  }, [_vm._v("水下机器人")]), _c("img", {
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260804/1785833127773.png",
      alt: ""
    }
  }), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.LabReportInfo.amountRobot || 0))])]), _c("div", [_c("div", {
    staticClass: "label"
  }, [_vm._v("智能投饵机")]), _c("img", {
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260804/1785833127773.png",
      alt: ""
    }
  }), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.LabReportInfo.amountFeeder || 0))])]), _c("div", [_c("div", {
    staticClass: "label"
  }, [_vm._v("AI摄像头")]), _c("img", {
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260804/1785833127773.png",
      alt: ""
    }
  }), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.LabReportInfo.amountCamera || 0))])]), _c("div", [_c("div", {
    staticClass: "label"
  }, [_vm._v("无人机")]), _c("img", {
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260804/1785833127773.png",
      alt: ""
    }
  }), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.LabReportInfo.amountUav || 0))])]), _c("div", [_c("div", {
    staticClass: "label"
  }, [_vm._v("无人车")]), _c("img", {
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260804/1785833127773.png",
      alt: ""
    }
  }), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.LabReportInfo.amountUgv || 0))])]), _c("div", {
    staticStyle: {
      "border-right": "2px solid #0BB7FF"
    }
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("无人船")]), _c("img", {
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260804/1785833127773.png",
      alt: ""
    }
  }), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.LabReportInfo.amountUsv || 0))])])]), _c("div", {
    attrs: {
      id: "map"
    }
  })]), _c("div", {
    staticClass: "right"
  }, [_c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("数字渔业示范企业")]), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "table"
  }, [_vm._m(2), _c("div", {
    staticClass: "t-content"
  }, _vm._l(_vm.lab_list, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "tr",
      class: {
        active: _vm.labId == item.labId
      },
      on: {
        click: function click($event) {
          _vm.labId = item.labId;
        }
      }
    }, [_vm.labId == item.labId ? _c("img", {
      attrs: {
        src: "https://oss-mng.rich-link.cn/undefined/20260730/1785403683241.png",
        alt: ""
      }
    }) : _vm._e(), _c("div", {
      staticClass: "td one-overflow",
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(item.name))]), _c("div", {
      staticClass: "td",
      staticStyle: {
        flex: "none",
        width: "100px"
      }
    }, [_vm._v(_vm._s(item.cultureMode || "--"))]), _c("div", {
      staticClass: "td",
      staticStyle: {
        flex: "none",
        width: "120px"
      }
    }, [_vm._v(_vm._s(item.cultureArea || "--"))]), _c("div", {
      staticClass: "td",
      staticStyle: {
        flex: "none",
        width: "120px"
      }
    }, [_vm._v(_vm._s(item.cultureWaterBody || "--"))])]);
  }), 0)])])]), _vm._m(3), _c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("企业产量统计（单位：万吨）")]), _c("div", {
    staticClass: "item-content"
  }, [_vm.labProductionTotal ? _c("pie3d", {
    attrs: {
      dataList: _vm.labProduction,
      total: _vm.labProductionTotal
    }
  }) : _vm._e()], 1)])])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("全国养殖产量（单位：万吨）")]), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "chart",
    attrs: {
      id: "chart1"
    }
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("省域产量统计（单位：万吨）")]), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "chart",
    attrs: {
      id: "chart2"
    }
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "th"
  }, [_c("div", {
    staticClass: "td"
  }, [_vm._v("企业名称")]), _c("div", {
    staticClass: "td",
    staticStyle: {
      flex: "none",
      width: "100px"
    }
  }, [_vm._v("养殖模式")]), _c("div", {
    staticClass: "td",
    staticStyle: {
      flex: "none",
      width: "120px"
    }
  }, [_vm._v("占地面积(亩)")]), _c("div", {
    staticClass: "td",
    staticStyle: {
      flex: "none",
      width: "120px"
    }
  }, [_vm._v("养殖水体(m³)")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("价格分析（单位：元）")]), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "chart",
    attrs: {
      id: "chart4"
    }
  })])]);
}];
render._withStripped = true;
export { render, staticRenderFns };